/**
 * Formats integer Stripe cents in `currency`, localized to `locale`, for display
 * (e.g. (999, 'usd', 'en-US') -> '$9.99'). Whole amounts drop the fraction (900 -> '$9').
 * The currency symbol and placement come from the browser, so this owns the entire rendered
 * string — callers should not append the currency code themselves. Uses the narrow symbol so the
 * bare glyph shows without a disambiguating country prefix (e.g. CNY -> '¥', not 'CN¥'). Falls back
 * to a bare symbol/code prefix for currency codes `Intl` can't resolve.
 */
export function formatCurrency(centsPerInterval: number, currency: string, locale: string): string {
  const amount = centsPerInterval / 100
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount)
  } catch {
    const symbol = currency.toUpperCase() === 'USD' ? '$' : currency.toUpperCase()
    return `${symbol}${amount}`
  }
}
